import React from 'react';
import Center from '../../../styled/Center';
import Button from '../../../styled/Button';
import { ChevronDownIcon } from '../../../styled/Icon';
import useContext from '../../../hooks/useContext';
import useCompose from '../../../hooks/useCompose';
import { CategoryContext } from './Providers/CategoryProvider';
import { useTrackGenericEvent } from '../../../hooks/tracking/useTrackingEvents';

const LoadMore = () => {
  const { disableLoadMore, loadMore, loading } = useContext(CategoryContext);

  const trackClickLoadMore = useTrackGenericEvent({ event: 'loadMoreProducts' });

  const onLoadMore = useCompose(trackClickLoadMore, loadMore);

  if (disableLoadMore) {
    return null;
  }

  return (
    <Center>
      <Button
        disabled={loading}
        onClick={onLoadMore}
        rounded
        size="large"
        title="Visa fler produkter"
        wide>
        <ChevronDownIcon className="m-r-half large" strokeWidth="2" />
        <span>Visa fler</span>
      </Button>
    </Center>
  );
};

export default LoadMore;
